var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.BUSY)?_c('div',{attrs:{"id":"spinner"}},[_c('i',{staticClass:"fas fa-3x fa-spinner fa-spin"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }